// extracted by mini-css-extract-plugin
export var deleteModal = "_f3-0";